// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TextFormattingMainView__button-ef9bda + .TextFormattingMainView__button-ef9bda {
  margin-inline-start: 6px;
}

.TextFormattingMainView__divider-a74a72 {
  width: 1px;
  height: 24px;
  margin: 0px 3px;
  background-color: var(--base-20);
}`, "",{"version":3,"sources":["webpack://./src/components/TextFormattingInput/TextFormattingMenu/TextFormattingMainView/TextFormattingMainView.styles.m.css"],"names":[],"mappings":"AAAA;EACE,wBAAA;AACF;;AAEA;EACE,UAAA;EACA,YAAA;EACA,eAAA;EACA,gCAAA;AACF","sourcesContent":[".button + .button {\n  margin-inline-start: 6px;\n}\n\n.divider {\n  width: 1px;\n  height: 24px;\n  margin: 0px 3px;\n  background-color: var(--base-20);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": `TextFormattingMainView__button-ef9bda`,
	"divider": `TextFormattingMainView__divider-a74a72`
};
module.exports = ___CSS_LOADER_EXPORT___;
